<template>
  <div id="userLogin">
    <div>
      <div class="big-img">
        <img
          src="./../../assets/kairan-big.jpg"
          alt=""
          class="kairan-big-img"
        />
      </div>
      <h2>
        <!-- <img src="./../../assets/kairan.jpg" alt="" class="kairan-img"> -->
        <span>请输入接入号/ICCID号/手机号</span>
      </h2>
      <form>
        <div>
          <keep-alive>
            <se-autocomplete
              v-model="iccid"
              :fetchsuggestions="querySearch"
              @select="handleSelect"
              placeholder="接入号/ICCID号/手机号"
            ></se-autocomplete>
          </keep-alive>
        </div>
        <div class="formLine">
          <mt-button type="primary" size="large" @click.prevent="userQuerySIM"
            >查询</mt-button
          >
        </div>
      </form>
    </div>

    <!-- <img style="width: 100%; margin-top: 2rem;" src="@/assets/advertising1.jpg" alt="" @click="goto('https://mp.weixin.qq.com/s/y0FifxzADSlj9yETKjpbtA')" /> -->

    <!-- <Advertisement></Advertisement> -->
    <!-- <p class="links">
           <a href="https://shimo.im/docs/Y7beSzRHODk0Nc1X/">充值说明</a>
           <a href="https://shimo.im/docs/cPeWt1msS0ogw2xM/">实名说明</a>
           <a href="http://kf.buy525.com/s/3314767bg">在线客服</a>
       </p> -->
  </div>
</template>
<script>
import { Dialog } from "vant";
import { Toast } from "vant";
import { wxRequest } from "@/api/user.js";
import SeAutocomplete from "@/components/SeAutocomplete";
import Advertisement from "@/components/Advertisement";
export default {
  components: { SeAutocomplete, Advertisement },
  data() {
    return {
      iccid: "",
      code: "",
      showAds: true,
      gzh: "",
      realNameList: [
        "1275374998751539200",
        "1275376520625385472",
        "1275377681088638976",
        "1275377775070408704",
        "1437713323280822272",
      ],
      authList: [
        "1377889272299778048",
        "1400032592278843392",
        "1275378097092292608",
        "1275376999107391488",
        "1275691791214964736",
        "1524283209066475520",
        "1521788173779202048",
        "1564193902288695296",
        "1275692094458949632",
        "1275378172963057664",
        "1339095354397683712",
        "1327522996776071168",
        "1275377601992454144",
        "1318030971152363520",
        "1481198323497955328",
        "1542127484164632576",
        "1275378312645963776",
        "1434761794559143936",
        "1435819372659601408",
        "1442788212572418048",
        "1275692038800535552",
        "1275691981858664448",
        "1275691916968587264",
        "1498840344832241664",
        "1561534552751468544",
        "1574649543113306112",
      ],
    };
  },
  methods: {
    querySearch(queryString, cb) {
      var listAll = this.getAutoCompleteData("iccidList");
      var results = queryString
        ? listAll.filter(this.createFilter(queryString))
        : listAll;
      cb(results);
    },
    createFilter(queryString) {
      return (listAll) => {
        return listAll.indexOf(queryString) == 0;
      };
    },
    handleSelect(item) {
      this.iccid = item;
    },
    userQuerySIM() {
      if (this.iccid == "") {
        Dialog.alert({ title: "提示", message: "请输入ICCID号" });
        return false;
      }

      let recordLoginText = this.iccid; //存放用户登录时输入的文本，将用于首页显示

      let data = {
        requestId: this.iccid,
        code: "1", //this.code
        isCode:"1"
       
      };
      wxRequest("sim/bind", data, "get").then((res) => {
        if (res.data.code == 200) {
          let record = res.data.data;
          let iccid = record.iccid;

          localStorage.setItem("mobile", record.mobile);
          localStorage.setItem("supplierTypeName", record.supplierTypeName);
          localStorage.setItem("wxHeadImg", record.wxHeadImg);
          localStorage.setItem("wxNickName", record.wxNickName);
          localStorage.setItem("recordLoginText", recordLoginText);
          localStorage.setItem("supplierName", record.supplierName);
          localStorage.setItem("yucun", record.yucun);
          localStorage.setItem("isSale", record.isSale);
          localStorage.setItem("ishavePkg", record.ishavePkg);
          localStorage.setItem("isSale", record.isSale);
          localStorage.setItem("iccid", iccid);
          sessionStorage.setItem("isLine", true); //用来判断投诉页面是否登录进来还是链接进来
          this.$store.state.recordLoginText = recordLoginText;
          this.$store.state.supplierCode = res.data.data.supplierCode;
          this.$store.state.iccid = iccid;
          this.$store.state.intoNo = record.intoNo;
          this.setAutoCompleteData("iccidList", recordLoginText, 10);
          if (record.isSale == 1 && record.ishavePrice == 0) {
            this.$router.replace("/user/simOpen19");
          } else if (record.isSale == 2 && record.ishavePrice == 0) {
            this.$router.replace("/user/simOpen9");
          } else if (record.isBind == 1) {
            this.$router.push({
              path: "/user/bindPhone1",
              query: {
                iccid: record.iccid,
              },
            });
          } else if (record.isBind == 2) {
            this.$router.push({
              path: "/user/bindPhone",
              query: {
                iccid: record.iccid,
              },
            });
          } else {
            this.$router.replace("/user/home");
          }

        //   //未实名的电信卡用户（通过cardType字段判断），实名认证时将只需要绑定
        //   let cardType = record.supplierCode;
        //   if (this.realNameList.indexOf(cardType) > -1) {
        //     let _data = { iccid: record.iccid };
        //     wxRequest("bindPhone/state", _data, "post").then((res) => {
        //       if (res.data.code == 200) {
        //         let result = res.data.data;
        //         localStorage.setItem(
        //           "applyChangeSimState",
        //           result.applyChangeSimState
        //         );
        //         if (result.bindState == 2) {
        //           this.$router.push({
        //             path: "/user/bindPhone",
        //             query: {
        //               iccid: record.iccid,
        //             },
        //           });
        //         } else {
        //           localStorage.setItem("phoneNo", result.userPhone);
        //           this.$router.replace("/user/home");
        //         }
        //       } else {
        //         Dialog.alert({ title: "提示", message: res.data.message });
        //       }
        //     });
        //   } else if (this.authList.indexOf(cardType) > -1) {
        //     let _data = { iccid: record.iccid };
        //     wxRequest("bindPhone/state", _data, "post").then((res) => {
        //       if (res.data.code == 200) {
        //         let result = res.data.data;
        //         localStorage.setItem(
        //           "applyChangeSimState",
        //           result.applyChangeSimState
        //         );
        //         if (result.bindState == 2) {
        //           this.$router.push({
        //             path: "/user/bindPhone1",
        //             query: {
        //               iccid: record.iccid,
        //             },
        //           });
        //         } else {
        //           localStorage.setItem("phoneNo", result.userPhone);
        //           this.$router.replace("/user/home");
        //         }
        //       } else {
        //         Dialog.alert({ title: "提示", message: res.data.message });
        //       }
        //     });
        //   } else {
        //     this.$router.replace("/user/home");
        //   }
        } else {
          Dialog.alert({ title: "提示", message: res.data.message });
        }
      });
    },

    //获取url参数
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    },

    // goto(path){
    //     //广告点击统计
    //     wxRequest("link/click",{url: path}, "get").then(res => {
    //         window.location.href = path;
    //     });

    // },
  },
  created() {
    var source = this.getQueryVariable("source")
      ? this.getQueryVariable("source")
      : process.env.VUE_APP_APPID;
    localStorage.setItem("appid", source);
    localStorage.setItem("isHeadquarterAppid", false);
    var appid = source ? source : process.env.VUE_APP_APPID;

    console.log(appid);
    var redirectUrl = window.location.href;
    var index = redirectUrl.indexOf("code");
    redirectUrl = encodeURIComponent(redirectUrl);
    // if (index < 0) {
    //   window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo#wechat_redirect`;
    // } else {
    //   var search = window.location.search;
    //   console.log("search", search);
    //   var startIndex = search.indexOf("code");
    //   var endIndex = search.indexOf("&", startIndex);
    //   var str = search.slice(startIndex, endIndex);
    //   var code = str.slice(str.indexOf("=") + 1);
    //   this.code = code;
    // }

    this.iccid = localStorage.getItem("recordLoginText");

    //获取总部公众号appid
    wxRequest("sim/appId", {}, "post").then((res) => {
      if (res.data.code == 200) {
        if (appid != res.data.data.collectAppid) {
          this.$store.commit("setIsHeadquarterAppid", "false");
          localStorage.setItem("isHeadquarterAppid", false);
        } else {
          this.$store.commit("setIsHeadquarterAppid", "true");
          localStorage.setItem("isHeadquarterAppid", true);
        }
      }
    });
  },

  mounted() {},

  beforeDestory() {},
};
</script>


<style scoped lang="less">
.big-img {
  text-align: center;
}
.kairan-big-img {
  height: 100px;
}
h2 {
  display: flex;
  align-items: center;
  .kairan-img {
    height: 20px;
    padding-right: 3px;
  }
}
.links {
  display: flex;
  margin-top: 25px;
  justify-content: space-around;
  a {
    border: 1px solid #26a2ff;
    border-radius: 30px;
    padding: 8px 0;
    margin: 0 15px;
    flex: 1;
    font-size: 16px;
    text-align: center;
  }
}
</style>